<script setup lang="ts">
import { computed } from 'vue'
import { NPagination, NInputNumber, NText } from 'naive-ui'
import { usePursuitFiltersUrl } from '@/composables/usePursuitFiltersUrl'

const props = defineProps<{ total: number }>()
const { filters, update } = usePursuitFiltersUrl()

const pageCount = computed(() =>
  Math.max(1, Math.ceil(props.total / filters.value.page_size)),
)

function onPage(p: number) {
  update({ page: p })
}
// Смена размера страницы или фильтра Мин возвращает на первую страницу.
function onPageSize(ps: number) {
  update({ page_size: ps, page: 1 })
}
function onMin(v: number | null) {
  if (v !== null && v >= 0) update({ min_appearances: v, page: 1 })
}

defineExpose({ pageCount, onPage, onPageSize, onMin })
</script>

<template>
  <div class="pursuit-footer">
    <div class="pager">
      <n-pagination
        :page="filters.page"
        :page-count="pageCount"
        :page-size="filters.page_size"
        :page-sizes="[25, 50, 100]"
        show-size-picker
        @update:page="onPage"
        @update:page-size="onPageSize"
      />
    </div>
    <div class="min-filter">
      <n-text depth="3">Мин:</n-text>
      <n-input-number
        :value="filters.min_appearances"
        :min="0"
        size="small"
        style="width: 90px"
        @update:value="onMin"
      />
      <n-text depth="3" class="min-hint">— мин. эпизодов сопровождения для показа</n-text>
    </div>
  </div>
</template>

<style scoped>
.pursuit-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  flex-wrap: wrap;
  margin-top: var(--sp-4);
  padding-top: var(--sp-3);
  border-top: 1px solid var(--line);
}
.pager { display: flex; align-items: center; }
.min-filter { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.min-hint { font-size: var(--fs-sm); }
</style>
